import { render, staticRenderFns } from "./PelatihanPesertaPreTest.vue?vue&type=template&id=9d4701e4"
import script from "./PelatihanPesertaPreTest.vue?vue&type=script&lang=js"
export * from "./PelatihanPesertaPreTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports